import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  AcademicCampClassData,
  AcademicMainClassData,
  ChangeClassData,
  CourseData,
  ListStudentFilter,
  ListStudentFilterAct,
  ListStudentResponse,
  ListStudentRombonganResponse,
  PaymentData,
  SelfCheckinLinkResponse,
  StudentData,
  StudentResumeDrilldownFilter,
  StudentResumeDrilldownResponse,
  StudentResumeFilter,
  StudentResumeResponse,
} from 'src/app/class/datatype';
import { environment } from 'src/environments/environment';

@Injectable()
export class StudentService {
  constructor(private http: HttpClient) {}

  listStudent(
    filter: ListStudentFilter,
    filterAct: ListStudentFilterAct
  ): Observable<ListStudentResponse> {
    let params = new HttpParams();

    if (filter.regcode && filterAct.regcode) {
      params = params.append('regcode', filter.regcode.toString());
    }

    if (filter.list_regcode) {
      filter.list_regcode.forEach((regcode) => {
        params = params.append('list_regcode[]', regcode.toString());
      });
    }

    if (filter.branch && filterAct.branch) {
      params = params.append('branch', filter.branch.toString());
    }

    if (filter.nis && filterAct.nis) {
      params = params.append('nis', filter.nis.toString());
    }

    if (filter.is_checked && filterAct.is_checked) {
      params = params.append('is_checked', filter.is_checked.toString());
    }

    if (filter.name && filterAct.name) {
      params = params.append('name', filter.name.toString());
    }

    if (filter.gender && filterAct.gender) {
      params = params.append('gender', filter.gender.toString());
    }

    if (filter.birthplace_id && filterAct.birthplace) {
      params = params.append('birthplace_id', filter.birthplace_id.toString());
    }

    if (filter.birthdate && filterAct.birthdate) {
      params = params.append('birthdate', filter.birthdate.toString());
    }

    if (filter.email && filterAct.email) {
      params = params.append('email', filter.email.toString());
    }

    if (filter.phone && filterAct.phone) {
      params = params.append('phone', filter.phone.toString());
    }

    if (filter.subdistrict_id && filterAct.subdistrict) {
      params = params.append(
        'subdistrict_id',
        filter.subdistrict_id.toString()
      );
    }

    if (filter.city_id && filterAct.city) {
      params = params.append('city_id', filter.city_id.toString());
    }

    if (filter.province_id && filterAct.province) {
      params = params.append('province_id', filter.province_id.toString());
    }

    if (filter.education && filterAct.education) {
      params = params.append('education', filter.education.toString());
    }

    if (filter.tshirt && filterAct.tshirt) {
      params = params.append('tshirt', filter.tshirt.toString());
    }

    if (filter.course && filterAct.course) {
      params = params.append('course', filter.course.toString());
    }

    if (filter.is_partial && filterAct.is_partial) {
      params = params.append('is_partial', filter.is_partial.toString());
    }

    if (filter.extendsProgram && filterAct.extendsProgram) {
      params = params.append('is_retention', filter.extendsProgram);
    }

    if (filter.courses) {
      filter.courses.forEach((course) => {
        params = params.append('courses[]', course);
      });
    }

    if (filter.grade) {
      filter.grade.forEach((grade) => {
        params = params.append('grade[]', grade);
      });
    }

    if (filter.meet_hour_id) {
      filter.meet_hour_id.forEach((meet_hour_id) => {
        params = params.append('meet_hour_id[]', meet_hour_id);
      });
    }

    if (filter.label_id && filterAct.label) {
      params = params.append('label_id', filter.label_id.toString());
    }

    if (filter.periode && filterAct.periode) {
      params = params.append('periode_date', filter.periode.date.toString());
      params = params.append('periode_month', filter.periode.month.toString());

      if (filter.periode.year) {
        params = params.append('periode_year', filter.periode.year.toString());
      }
    }

    if (filter.camp && filterAct.camp) {
      params = params.append('camp', filter.camp.toString());
    }

    if (filter.camps) {
      filter.camps.forEach((camp) => {
        params = params.append('camps[]', camp);
      });
    }

    if (filter.placement_test) {
      params = params.append('placement_test', filter.placement_test);
    }

    if (filter.min_pt) {
      params = params.append('min_pt', filter.min_pt);
    }

    if (filter.max_pt) {
      params = params.append('max_pt', filter.max_pt);
    }

    if (filter.main_class && filterAct.main_class) {
      params = params.append('main_class', filter.main_class.toString());
    }

    if (filter.camp_class && filterAct.camp_class) {
      params = params.append('camp_class', filter.camp_class.toString());
    }

    if (filter.has_mainclass !== null && filter.has_mainclass !== undefined) {
      params = params.append('has_mainclass', filter.has_mainclass.toString());
    }

    if (filter.has_campclass !== null && filter.has_campclass !== undefined) {
      params = params.append('has_campclass', filter.has_campclass.toString());
    }

    if (filter.need_class !== null && filter.need_class !== undefined) {
      params = params.append('need_class', filter.need_class.toString());
    }

    if (filter.status && filterAct.status) {
      params = params.append('status', filter.status.toString());
    }

    if (filter.lead && filterAct.lead) {
      params = params.append('lead', filter.lead.toString());
    }

    if (filter.aff && filterAct.aff) {
      params = params.append('aff', filter.aff.toString());
    }

    if (filter.cs && filterAct.cs) {
      params = params.append('cs', filter.cs.toString());
    }

    if (filter.startDate && filterAct.startDate) {
      params = params.append('startDate', filter.startDate.toString());
    }

    if (filter.endDate && filterAct.endDate) {
      params = params.append('endDate', filter.endDate.toString());
    }

    if (filter.checkinStartDate && filterAct.checkinStartDate) {
      params = params.append('checkinStartDate', filter.checkinStartDate.toString());
    }

    if (filter.checkinEndDate && filterAct.checkinEndDate) {
      params = params.append('checkinEndDate', filter.checkinEndDate.toString());
    }

    if (filter.checkinDate && filterAct.checkinDate) {
      params = params.append('checkinDate', filter.checkinDate.toString());
    }

    if (filter.with_academic) {
      params = params.append('with_academic', 1);
    }

    if (filter.academic_month) {
      params = params.append('academic_month', filter.academic_month);
    }

    if (filter.with_certificate) {
      params = params.append('with_certificate', 1);
    }

    if (filter.order) {
      params = params.append('order', filter.order);
    }

    if (filter.voucher) {
      params = params.append('voucher', filter.voucher);
    }

    if (filter.pickup && filterAct.pickup) {
      params = params.append('pickup', filter.pickup.toString());
    }

    if (filter.pickupLocation && filterAct.pickupLocation) {
      params = params.append('pickupLocation', filter.pickupLocation.toString());
    }

    if (filter.passenger && filterAct.passenger) {
      params = params.append('passenger', filter.passenger.toString());
    }

    if (filter.pickupTime && filterAct.pickupTime) {
      params = params.append('pickupTime', filter.pickupTime.toString());
    }

    if (filter.order_by) {
      params = params.append('order_by', filter.order_by);
    }

    params = params.append('download', filter.download);
    params = params.append('page', filter.page.toString());
    params = params.append('per_page', filter.per_page.toString());

    return this.http.get<ListStudentResponse>(
      environment.apiUrl + 'clientapi/student',
      { params }
    );
  }

  exportStudent(
    filter: ListStudentFilter,
    filterAct: ListStudentFilterAct,
    format: 'csv' | 'xlsx' = 'csv'
  ): Observable<HttpResponse<Blob>> {
    let params = new HttpParams();

    if (filter.regcode && filterAct.regcode) {
      params = params.append('regcode', filter.regcode.toString());
    }

    if (filter.list_regcode) {
      filter.list_regcode.forEach((regcode) => {
        params = params.append('list_regcode[]', regcode.toString());
      });
    }

    if (filter.branch && filterAct.branch) {
      params = params.append('branch', filter.branch.toString());
    }

    if (filter.nis && filterAct.nis) {
      params = params.append('nis', filter.nis.toString());
    }

    if (filter.is_checked && filterAct.is_checked) {
      params = params.append('is_checked', filter.is_checked.toString());
    }

    if (filter.name && filterAct.name) {
      params = params.append('name', filter.name.toString());
    }

    if (filter.gender && filterAct.gender) {
      params = params.append('gender', filter.gender.toString());
    }

    if (filter.birthplace_id && filterAct.birthplace) {
      params = params.append('birthplace_id', filter.birthplace_id.toString());
    }

    if (filter.birthdate && filterAct.birthdate) {
      params = params.append('birthdate', filter.birthdate.toString());
    }

    if (filter.email && filterAct.email) {
      params = params.append('email', filter.email.toString());
    }

    if (filter.phone && filterAct.phone) {
      params = params.append('phone', filter.phone.toString());
    }

    if (filter.subdistrict_id && filterAct.subdistrict) {
      params = params.append(
        'subdistrict_id',
        filter.subdistrict_id.toString()
      );
    }

    if (filter.city_id && filterAct.city) {
      params = params.append('city_id', filter.city_id.toString());
    }

    if (filter.province_id && filterAct.province) {
      params = params.append('province_id', filter.province_id.toString());
    }

    if (filter.education && filterAct.education) {
      params = params.append('education', filter.education.toString());
    }

    if (filter.tshirt && filterAct.tshirt) {
      params = params.append('tshirt', filter.tshirt.toString());
    }

    if (filter.course && filterAct.course) {
      params = params.append('course', filter.course.toString());
    }

    if (filter.is_partial && filterAct.is_partial) {
      params = params.append('is_partial', filter.is_partial.toString());
    }

    if (filter.extendsProgram && filterAct.extendsProgram) {
      params = params.append('is_retention', filter.extendsProgram);
    }

    if (filter.courses) {
      filter.courses.forEach((course) => {
        params = params.append('courses[]', course);
      });
    }

    if (filter.grade) {
      filter.grade.forEach((grade) => {
        params = params.append('grade[]', grade);
      });
    }

    if (filter.meet_hour_id) {
      filter.meet_hour_id.forEach((meet_hour_id) => {
        params = params.append('meet_hour_id[]', meet_hour_id);
      });
    }

    if (filter.label_id && filterAct.label) {
      params = params.append('label_id', filter.label_id.toString());
    }

    if (filter.periode && filterAct.periode) {
      params = params.append('periode_date', filter.periode.date.toString());
      params = params.append('periode_month', filter.periode.month.toString());

      if (filter.periode.year) {
        params = params.append('periode_year', filter.periode.year.toString());
      }
    }

    if (filter.camp && filterAct.camp) {
      params = params.append('camp', filter.camp.toString());
    }

    if (filter.camps) {
      filter.camps.forEach((camp) => {
        params = params.append('camps[]', camp);
      });
    }

    if (filter.placement_test) {
      params = params.append('placement_test', filter.placement_test);
    }

    if (filter.min_pt) {
      params = params.append('min_pt', filter.min_pt);
    }

    if (filter.max_pt) {
      params = params.append('max_pt', filter.max_pt);
    }

    if (filter.main_class && filterAct.main_class) {
      params = params.append('main_class', filter.main_class.toString());
    }

    if (filter.camp_class && filterAct.camp_class) {
      params = params.append('camp_class', filter.camp_class.toString());
    }

    if (filter.has_mainclass !== null && filter.has_mainclass !== undefined) {
      params = params.append('has_mainclass', filter.has_mainclass.toString());
    }

    if (filter.has_campclass !== null && filter.has_campclass !== undefined) {
      params = params.append('has_campclass', filter.has_campclass.toString());
    }

    if (filter.need_class !== null && filter.need_class !== undefined) {
      params = params.append('need_class', filter.need_class.toString());
    }

    if (filter.status && filterAct.status) {
      params = params.append('status', filter.status.toString());
    }

    if (filter.lead && filterAct.lead) {
      params = params.append('lead', filter.lead.toString());
    }

    if (filter.aff && filterAct.aff) {
      params = params.append('aff', filter.aff.toString());
    }

    if (filter.cs && filterAct.cs) {
      params = params.append('cs', filter.cs.toString());
    }

    if (filter.startDate && filterAct.startDate) {
      params = params.append('startDate', filter.startDate.toString());
    }

    if (filter.endDate && filterAct.endDate) {
      params = params.append('endDate', filter.endDate.toString());
    }

    if (filter.checkinStartDate && filterAct.checkinStartDate) {
      params = params.append('checkinStartDate', filter.checkinStartDate.toString());
    }

    if (filter.checkinEndDate && filterAct.checkinEndDate) {
      params = params.append('checkinEndDate', filter.checkinEndDate.toString());
    }

    if (filter.checkinDate && filterAct.checkinDate) {
      params = params.append('checkinDate', filter.checkinDate.toString());
    }

    if (filter.with_academic) {
      params = params.append('with_academic', 1);
    }

    if (filter.academic_month) {
      params = params.append('academic_month', filter.academic_month);
    }

    if (filter.with_certificate) {
      params = params.append('with_certificate', 1);
    }

    if (filter.order) {
      params = params.append('order', filter.order);
    }

    if (filter.voucher) {
      params = params.append('voucher', filter.voucher);
    }

    if (filter.pickup && filterAct.pickup) {
      params = params.append('pickup', filter.pickup.toString());
    }

    if (filter.pickupLocation && filterAct.pickupLocation) {
      params = params.append('pickupLocation', filter.pickupLocation.toString());
    }

    if (filter.passenger && filterAct.passenger) {
      params = params.append('passenger', filter.passenger.toString());
    }

    if (filter.pickupTime && filterAct.pickupTime) {
      params = params.append('pickupTime', filter.pickupTime.toString());
    }

    if (filter.order_by) {
      params = params.append('order_by', filter.order_by);
    }

    params = params.append('format', format);

    return this.http.get(
      environment.apiUrl + 'clientapi/student/download',
      {
        params,
        responseType: 'blob',
        observe: 'response',
      }
    );
  }

  listStudentRombongan(
    filter: ListStudentFilter,
    filterAct: ListStudentFilterAct
  ): Observable<ListStudentRombonganResponse> {
    let params = new HttpParams();

    if (filter.regcode && filterAct.regcode) {
      params = params.append('regcode', filter.regcode.toString());
    }

    if (filter.list_regcode) {
      filter.list_regcode.forEach((regcode) => {
        params = params.append('list_regcode[]', regcode.toString());
      });
    }

    if (filter.branch && filterAct.branch) {
      params = params.append('branch', filter.branch.toString());
    }

    if (filter.nis && filterAct.nis) {
      params = params.append('nis', filter.nis.toString());
    }

    if (filter.name && filterAct.name) {
      params = params.append('name', filter.name.toString());
    }

    if (filter.gender && filterAct.gender) {
      params = params.append('gender', filter.gender.toString());
    }

    if (filter.birthplace_id && filterAct.birthplace) {
      params = params.append('birthplace_id', filter.birthplace_id.toString());
    }

    if (filter.birthdate && filterAct.birthdate) {
      params = params.append('birthdate', filter.birthdate.toString());
    }

    if (filter.email && filterAct.email) {
      params = params.append('email', filter.email.toString());
    }

    if (filter.phone && filterAct.phone) {
      params = params.append('phone', filter.phone.toString());
    }

    if (filter.subdistrict_id && filterAct.subdistrict) {
      params = params.append(
        'subdistrict_id',
        filter.subdistrict_id.toString()
      );
    }

    if (filter.city_id && filterAct.city) {
      params = params.append('city_id', filter.city_id.toString());
    }

    if (filter.province_id && filterAct.province) {
      params = params.append('province_id', filter.province_id.toString());
    }

    if (filter.education && filterAct.education) {
      params = params.append('education', filter.education.toString());
    }

    if (filter.tshirt && filterAct.tshirt) {
      params = params.append('tshirt', filter.tshirt.toString());
    }

    if (filter.course && filterAct.course) {
      params = params.append('course', filter.course.toString());
    }

    if (filter.is_partial && filterAct.is_partial) {
      params = params.append('is_partial', filter.is_partial.toString());
    }

    if (filter.courses) {
      filter.courses.forEach((course) => {
        params = params.append('courses[]', course);
      });
    }

    if (filter.periode && filterAct.periode) {
      params = params.append('periode_date', filter.periode.date.toString());
      params = params.append('periode_month', filter.periode.month.toString());

      if (filter.periode.year) {
        params = params.append('periode_year', filter.periode.year.toString());
      }
    }

    if (filter.camp && filterAct.camp) {
      params = params.append('camp', filter.camp.toString());
    }

    if (filter.camps) {
      filter.camps.forEach((camp) => {
        params = params.append('camps[]', camp);
      });
    }

    if (filter.placement_test) {
      params = params.append('placement_test', filter.placement_test);
    }

    if (filter.min_pt) {
      params = params.append('min_pt', filter.min_pt);
    }

    if (filter.max_pt) {
      params = params.append('max_pt', filter.max_pt);
    }

    if (filter.main_class && filterAct.main_class) {
      params = params.append('main_class', filter.main_class.toString());
    }

    if (filter.camp_class && filterAct.camp_class) {
      params = params.append('camp_class', filter.camp_class.toString());
    }

    if (filter.has_mainclass !== null && filter.has_mainclass !== undefined) {
      params = params.append('has_mainclass', filter.has_mainclass.toString());
    }

    if (filter.has_campclass !== null && filter.has_campclass !== undefined) {
      params = params.append('has_campclass', filter.has_campclass.toString());
    }

    if (filter.need_class !== null && filter.need_class !== undefined) {
      params = params.append('need_class', filter.need_class.toString());
    }

    if (filter.status && filterAct.status) {
      params = params.append('status', filter.status.toString());
    }

    if (filter.lead && filterAct.lead) {
      params = params.append('lead', filter.lead.toString());
    }

    if (filter.aff && filterAct.aff) {
      params = params.append('aff', filter.aff.toString());
    }

    if (filter.cs && filterAct.cs) {
      params = params.append('cs', filter.cs.toString());
    }

    if (filter.startDate && filterAct.startDate) {
      params = params.append('startDate', filter.startDate.toString());
    }

    if (filter.endDate && filterAct.endDate) {
      params = params.append('endDate', filter.endDate.toString());
    }

    if (filter.checkinStartDate && filterAct.checkinStartDate) {
      params = params.append('checkinStartDate', filter.checkinStartDate.toString());
    }

    if (filter.checkinEndDate && filterAct.checkinEndDate) {
      params = params.append('checkinEndDate', filter.checkinEndDate.toString());
    }

    if (filter.checkinDate && filterAct.checkinDate) {
      params = params.append('checkinDate', filter.checkinDate.toString());
    }

    if (filter.with_academic) {
      params = params.append('with_academic', 1);
    }

    if (filter.academic_month) {
      params = params.append('academic_month', filter.academic_month);
    }

    if (filter.with_certificate) {
      params = params.append('with_certificate', 1);
    }

    if (filter.order) {
      params = params.append('order', filter.order);
    }

    if (filter.order_by) {
      params = params.append('order_by', filter.order_by);
    }

    params = params.append('download', filter.download);
    params = params.append('page', filter.page.toString());
    params = params.append('per_page', filter.per_page.toString());

    return this.http.get<ListStudentRombonganResponse>(
      environment.apiUrl + 'clientapi/student/rombongan',
      { params }
    );
  }

  getStudent(
    studentId: number,
    options?: {
      course?: number;
      camp?: number;
      payment?: number;
      academic?: number;
    }
  ): Observable<StudentData> {
    let params = new HttpParams();

    if (options) {
      if (options.course) {
        params = params.append('course', options.course.toString());
      }

      if (options.camp) {
        params = params.append('camp', options.camp.toString());
      }

      if (options.payment) {
        params = params.append('payment', options.payment.toString());
      }

      if (options.academic) {
        params = params.append('academic', options.academic.toString());
      }
    }

    return this.http.get<StudentData>(
      environment.apiUrl + 'clientapi/student/' + studentId,
      { params }
    );
  }

  /** Buat link self check-in (JWT berisi regcode, berlaku 7 hari) untuk dipakai siswa di cprint */
  generateSelfCheckinLink(studentId: number): Observable<SelfCheckinLinkResponse> {
    return this.http.post<SelfCheckinLinkResponse>(
      environment.apiUrl + 'clientapi/student/' + studentId + '/self-checkin-link',
      {}
    );
  }

  updateStudent(studentId: number, action: string): Observable<StudentData> {
    return this.http.put<StudentData>(
      environment.apiUrl + 'clientapi/student/' + studentId,
      { action }
    );
  }

  savePayment(data: PaymentData): Observable<any> {
    return this.http.post<any>(
      environment.apiUrl + 'clientapi/student/payment',
      data
    );
  }

  saveOnCheck(studentId: number,): Observable<any> {
    return this.http.put<any>(
      environment.apiUrl + 'clientapi/student/registration/checked/' + studentId,
      {}
    );
  }

  changeCourse(student: StudentData, course: CourseData): Observable<any> {
    return this.http.put(
      environment.apiUrl +
        'clientapi/student/update-course/' +
        student.id +
        '/' +
        course.id,
      {}
    );
  }

  changeCamp(studentId: number, targetCampId: number): Observable<any> {
    return this.http.post(
      environment.apiUrl +
        'clientapi/student/change-camp/' +
        studentId +
        '/' +
        targetCampId,
      {}
    );
  }

  changeGrade(studentId: number, targetGradeId: number): Observable<any> {
    return this.http.post(
      environment.apiUrl +
        'clientapi/student/change-grade/' +
        studentId +
        '/' +
        targetGradeId,
      {}
    );
  }

  getLabels(studentId: number): Observable<any> {
    return this.http.get(
      environment.apiUrl + 'clientapi/student/' + studentId + '/labels'
    );
  }

  setLabels(studentId: number, labelIds: number[]): Observable<any> {
    return this.http.post(
      environment.apiUrl + 'clientapi/student/' + studentId + '/labels',
      { label_ids: labelIds }
    );
  }

  mapClasses(
    students: StudentData[],
    mainClass: AcademicMainClassData,
    campClass: AcademicCampClassData
  ): Observable<unknown> {
    return this.http.post(environment.apiUrl + 'clientapi/student/map-class', {
      students: students.map((s) => s.id),
      main_class: mainClass ? mainClass.id : null,
      camp_class: campClass ? campClass.id : null,
    });
  }

  changeClass(data: ChangeClassData): Observable<any> {
    return this.http.post(
      environment.apiUrl + 'clientapi/student/change-class',
      {
        students_id: data.students.map((n) => n.id),
        main_class: data.mainClass ? data.mainClass.id : null,
        camp_class: data.campClass ? data.campClass.id : null,
      }
    );
  }

  dropout(student: StudentData): Observable<any> {
    return this.http.post(environment.apiUrl + 'clientapi/student/dropout', {
      student_id: student.id,
    });
  }

  placementTest(students: StudentData[]): Observable<any> {
    return this.http.post(
      environment.apiUrl + 'clientapi/student/placement-test',
      {
        students: students.map((n) => {
          return {
            id: n.id,
            pt_grammar: n.pt_grammar,
            pt_speaking: n.pt_speaking,
          };
        }),
      }
    );
  }

  readTemplate(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append(
      'Accept',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );

    return this.http.get('assets/PLACEMENTTEST.xlsx', {
      responseType: 'blob' as 'json',
    });
  }

  getMemberData(data: StudentData): Observable<any> {
    let params = new HttpParams();

    params = params.append('regcode', data.regcode.toString());
    params = params.append('email', data.email.toString());
    params = params.append('status', data.status.toString());

    return this.http.get(
      environment.apiUrl + 'clientapi/registration/get-member-biodata',
      { params }
    );
  }

  getMemberRetentionData(): Observable<any> {
    return this.http.get(
      environment.apiUrl + 'clientapi/registration/get-member-retention-data'
    );
  }

  getStudentResume(
    filter: StudentResumeFilter
  ): Observable<StudentResumeResponse> {
    let params = new HttpParams().append('periode', filter.periode);
    if (filter.branch) {
      params = params.append('branch', filter.branch);
    }
    // '0' adalah nilai filter yang valid (Tidak) — hanya '' (Semua) yang dilewati.
    if (filter.is_retention !== '' && filter.is_retention !== undefined) {
      params = params.append('is_retention', filter.is_retention);
    }
    if (filter.is_rombongan !== '' && filter.is_rombongan !== undefined) {
      params = params.append('is_rombongan', filter.is_rombongan);
    }
    return this.http.get<StudentResumeResponse>(
      environment.apiUrl + 'clientapi/student/resume',
      { params }
    );
  }

  getStudentResumeStudents(
    filter: StudentResumeDrilldownFilter
  ): Observable<StudentResumeDrilldownResponse> {
    let params = new HttpParams();
    Object.entries(filter).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, value.toString());
      }
    });
    return this.http.get<StudentResumeDrilldownResponse>(
      environment.apiUrl + 'clientapi/student/resume/students',
      { params }
    );
  }

  /**
   * Unduh daftar siswa di balik Resume Siswa (seluruh populasi, atau satu sel
   * bila filter dimensi diisi). Nama file diambil dari header content-disposition.
   */
  downloadResumeStudents(
    filter: StudentResumeDrilldownFilter,
    format: 'csv' | 'xlsx' = 'csv'
  ): Observable<{ blob: Blob; filename: string }> {
    let params = new HttpParams().append('format', format);
    Object.entries(filter).forEach(([key, value]) => {
      if (
        key !== 'page' &&
        key !== 'per_page' &&
        value !== undefined &&
        value !== null &&
        value !== ''
      ) {
        params = params.append(key, value.toString());
      }
    });
    return this.http
      .get(environment.apiUrl + 'clientapi/student/resume/download', {
        params,
        responseType: 'blob',
        observe: 'response',
      })
      .pipe(
        map((response) => {
          const contentDisposition =
            response.headers.get('content-disposition') || '';
          let filename = 'resume_siswa.' + format;
          const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(
            contentDisposition
          );
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
          }
          return { blob: response.body, filename };
        })
      );
  }
}
